<div class="event-header" [ngStyle]="{'background-color':settingsData?.event_bg_primary_color}">
  <!-- throwingdj-Section Start  -->

  <div class="header-Section " [ngStyle]="{'background-color':settingsData?.event_bg_primary_color,'color':settingsData?.event_font_primary_color}">
    <div class="row no-gutters align-items-center">
      <div class="col-12 col-md-10 col-lg-11 throwing-dj-calandersection">
        <div class="row  align-items-center no-gutters">
          <div class="col-12 col-md-11 col-lg-8">
            <div class="row align-items-center">
              <div class="col-12  col-md-5 col-xl-5 party-div mb-5">
                <div class="profile-icon m-o mr-15 text-center f-l"
                  *ngIf="streamInfo && streamInfo?.video_thumbnail_image == null">
                  {{streamInfo?.displayTitleName}}</div>
                <div class="artist-pic m-o mr-15 mt-5 pointer profile-pic notranslate f-l"
                  *ngIf="streamInfo?.video_thumbnail_image != null"
                  [ngStyle]="{'background-image':' url(' + streamInfo?.video_thumbnail_image + ')','background-size':'contain'}">
                </div>
                <h1 class="event-title mb-0 pt-8"
                  [ngClass]="{'pt-15':streamInfo?.short_description =='null' || streamInfo?.short_description == null}"
                  *ngIf="streamInfo?.stream_video_title && streamInfo?.stream_video_title.length <= 13">
                  {{streamInfo?.stream_video_title}}</h1>
                <h1 class="event-title mb-0 pt-8"
                  [ngClass]="{'pt-15':streamInfo?.short_description =='null' || streamInfo?.short_description == null}"
                  *ngIf="streamInfo?.stream_video_title && streamInfo?.stream_video_title.length > 13"
                  matTooltipPosition="above" matTooltip="{{streamInfo?.stream_video_title}}">
                  {{streamInfo?.stream_video_title | slice: 0:13}}
                  {{streamInfo?.stream_video_title.length > 13 ? "..." : ""}}
                </h1>
                <p class="event-desc secondary-bg-font-color1 ml-65 mb-0"
                [style.color]="settingsData?.event_font_primary_color +'!important'"
                  *ngIf="streamInfo?.short_description !='null' && streamInfo?.short_description && streamInfo?.short_description.length <= 28">
                  {{streamInfo?.short_description}}</p>
                <p class="event-desc ml-65 mb-0"
                [style.color]="settingsData?.event_font_primary_color +'!important'"
                  *ngIf="streamInfo?.short_description !='null' && streamInfo?.short_description &&  streamInfo?.short_description.length > 28"
                  matTooltipPosition="above" matTooltip="{{streamInfo?.short_description}}">
                  {{streamInfo?.short_description | slice: 0:28}}
                  {{streamInfo?.short_description.length > 28 ? "..." : ""}}
                </p>
              </div>
              <div class="col-12 col-md-7 col-lg-7 age-watch-section">
                <div class="row">
                  <div class="col-6 col-md-6 col-lg-6 start-section-col">
                    <div class="start-section  ">
                      <h5 class="secondary-bg-font-color1"><i class="fa fa-user" aria-hidden="true" [style.color]="settingsData?.event_font_primary_color +'!important'"></i>
                        <span [style.color]="settingsData?.event_font_primary_color +'!important'">For Age</span>
                      </h5>
                      <h6>
                        {{streamInfo?.ageInfo}}
                      </h6>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6">
                    <div class=" start-section  ">
                      <h5 class="secondary-bg-font-color1"><i class="fa fa-video-camera" aria-hidden="true" [style.color]="settingsData?.event_font_primary_color +'!important'"></i>
                        <span [style.color]="settingsData?.event_font_primary_color +'!important'">Watch {{isLiveTickets ? "at" : "on"}}
                          <!-- <span *ngIf="!isLiveTickets">on</span>
                          <span *ngIf="isLiveTickets">at</span> -->
                        </span></h5>
                      <h6 class="pl-27">
                        <!-- Arevea -->
                        <ng-container *ngIf="!isLiveTickets">
                          <span *ngIf="!channelName">{{clientDetails.slug}}</span>
                          <span *ngIf="channelName">{{channelName}}</span>
                        </ng-container>
                        <span *ngIf="isLiveTickets"><i class="material-icons fs-13"> room </i>
                          {{settingsJSON.venue_address.venue_name}}</span>
                      </h6>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="col-12 col-md-12 col-lg-4 col-xl-4 sub-section" *ngIf="subEvents?.length > 0">
            <div class="row justify-content-center">
              <div class="col-12 col-md-112 col-lg-11">
                <div class="date-block  row no-gutters" [ngStyle]="{'background-color':settingsData?.event_bg_secondary_color,'color':settingsData?.event_font_secondary_color}">
                  <div class="col-2 col-md-1 mr-20">
                    <i class="fa fa-calendar-check-o fs-18" aria-hidden="true"></i>
                  </div>
                  <div class="col-10 col-md-11 row">
                    <ng-container *ngIf="streamInfo?.stream_vod == 'stream'
                    ">
                      <ng-container *ngIf="streamInfo?.selected_type == 'single_session_event'">
                        <div class="party-date notranslate">{{streamInfo?.eventStart}} - {{streamInfo?.eventEnd}}</div>
                      </ng-container>
                      <ng-container
                        *ngIf="(streamInfo?.recurring_type != '' && streamInfo?.recurring_type != null) && streamInfo?.selected_type != 'single_session_event' && streamInfo?.selected_type != 'single_day_event'">
                        <div *ngFor="let date of datesList;let last = last;" class="date-txt notranslate">
                          <span class="pr-5">{{date.start}}{{last
                            ? '' : ', '}}</span>
                        </div>
                        <!-- <div *ngFor="let date of datesList" class="date-txt notranslate">
                          <h5>{{date.start}}</h5>
                        </div> -->
                      </ng-container>
                      <ng-container
                        *ngIf="streamInfo?.selected_type == 'single_day_event' || streamInfo?.selected_type == 'multi_day_event'">
                        <div class="party-date notranslate" *ngIf="datesList.length == 1">{{eventStartDate}} </div>
                        <div class="party-date notranslate" *ngIf="datesList.length > 1">{{eventStartDate}} -
                          {{eventEndDate}} </div>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="streamInfo?.stream_vod == 'vod'
                    ">
                      <div class="party-date notranslate">{{eventStartDate}}</div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-5  col-md-2 col-lg-1 text-right btn-div" [ngClass]="{'mt-10':isMobile}"
        *ngIf="!router.url.includes('claim-tickets')">
        <button mat-raised-button class="back-btn" *ngIf="!isMobile" (click)=" backClicked()"
        [style.color]="settingsData?.event_font_primary_color +'!important'"
        [style.border]="'1px solid'+settingsData?.event_font_primary_color"> Back</button>
        <a class="back-btn p-10 mt-5" *ngIf="isMobile" target="_other" rel="nofollow"
          [href]="backRedirectionUrl">Back</a>
      </div>
    </div>
  </div>
  <!-- throwingdj-Section End -->
</div>

<!-- <div class="app-header ">
      <div class="box-bg">
          <div fxLayout="row" class="w-100 mb-2">
              <div fxFlex="5%" fxFlex.xs="20%" fxFlex.sm="10%" fxFlex.md="7%">
                  <div class="profile-icon m-o text-center"
                      *ngIf="streamInfo && streamInfo?.video_thumbnail_image == null">
                      {{streamInfo?.displayTitleName}}</div>
                  <div class="artist-pic m-o mt-5 pointer profile-pic" *ngIf="streamInfo?.video_thumbnail_image != null"
                      [ngStyle]="{'background-image':' url(' + streamInfo?.video_thumbnail_image + ')'}"></div>
              </div>
              <div fxFlex="75%" fxFlex.xs="60%" fxFlex.sm="80%" fxFlex.md="73%">
                  <div class="text-left fw-500 fs-24 lh-30 b-title">
                      <span  fxHide.xs="true" fxShow> {{streamInfo?.stream_video_title}}
                      </span>
                      <span fxShow.xs="true" fxHide
                          *ngIf="streamInfo?.stream_video_title.length <= 10"
                          class="pointer pl-5">{{streamInfo?.stream_video_title}}
                      </span>
                      <span fxShow.xs="true" fxHide
                      *ngIf="streamInfo?.stream_video_title.length > 10" matTooltipPosition="above"
                          matTooltip="{{streamInfo?.stream_video_title}}" class="pointer pl-5">
                          {{streamInfo?.stream_video_title | slice: 0:10}}
                          {{streamInfo?.stream_video_title.length > 10 ? "..." : ""}}
                      </span>
                  </div>streamInfo?.short_description !='null'
              </div>
              <div fxFlex="20%" fxFlex.xs="20%" fxFlex.sm="10%" fxFlex.md="20%">
                  <div class="text-right tl pt0 b-title">
                      <button class="back-btn" (click)=" backClicked()"> Back</button>
                  </div>
              </div>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="10px grid" fxLayoutGap.xs="20px grid" fxLayoutGap.sm="20px grid"
              class="w-100 mt-2">
              <div fxFlex="2%" fxFlex.xs="10%" fxFlex.sm="10%" fxFlex.md="3%" class="text-right fs-17">
                  <i class="fa fa-calendar" aria-hidden="true"></i>
              </div>
              <div fxFlex="23%" fxFlex.xs="90%" fxFlex.sm="90%" fxFlex.md="26%">
                  <p><span class="c-o fw-500 fs-18 mb-2">Date & Time</span></p>
                  <p class="mb-5">{{streamInfo?.date}}
                      <br>{{streamInfo?.time}} </p>
              </div>
              <div fxFlex="8%" fxFlex.xs="10%" fxFlex.sm="10%" fxFlex.md="6%" class="text-right fs-17">
                  <i class="fa fa-video-camera" aria-hidden="true"></i>
              </div>
              <div fxFlex="9%" fxFlex.xs="90%" fxFlex.sm="90%" fxFlex.md="13%">
                  <p class="c-o fw-500 fs-18 mb-2">Watch on</p>
                  <p class="mb-5">Arevea</p>
  
              </div>
              <div fxFlex="8%" fxFlex.xs="10%" fxFlex.sm="10%" fxFlex.md="8%" class="text-right fs-17">
                  <i class="fa fa-user" aria-hidden="true"></i>
              </div>
              <div fxFlex="50%" fxFlex.xs="90%" fxFlex.sm="90%" fxFlex.md="44%">
                  <p class="c-o fw-500 fs-18 mb-2">For Age</p>
                  <p class="mb-5">{{streamInfo?.ageInfo}}</p>
              </div>
          </div>
      </div>
  </div> -->